// DrawerDirtyMixin — add to any drawer-content form to participate in the
// LayerHost unsaved-changes guard. The no-op default in `inject` keeps the
// mixin inert when the component renders outside a LayerHost (e.g. legacy
// /sites tabs, finance, property, progress pages).

export default {
  inject: {
    drawerDirtyRegistry: {
      default: function () {
        return {
          register: function () {},
          unregister: function () {},
          notifyDirtyChange: function () {}
        }
      }
    }
  },

  data () {
    return {
      drawerDirty: false
    }
  },

  watch: {
    drawerDirty: function (v) {
      this.drawerDirtyRegistry.notifyDirtyChange(v)
    }
  },

  methods: {
    // Close-time dirty check. Read fresh by the LayerHost guard when the user
    // tries to close the drawer. Overridable: a component can augment it — e.g.
    // EditPane also diffs its form fields so a pane the user edited (without
    // toggling edit mode) still guards. Default is the reactive boolean flag.
    isDrawerContentDirty () {
      return this.drawerDirty
    }
  },

  created () {
    this._dirtyChecker = function () { return this.isDrawerContentDirty() }.bind(this)
    this.drawerDirtyRegistry.register(this._dirtyChecker)
  },

  beforeDestroy () {
    this.drawerDirtyRegistry.unregister(this._dirtyChecker)
    // If the component is torn down while dirty, clear the count so the
    // registry doesn't permanently consider this layer dirty.
    if (this.drawerDirty) {
      this.drawerDirtyRegistry.notifyDirtyChange(false)
    }
  }
}
